import '../../styles/footer.scss';
import { useLocation } from "react-router-dom";
import { useMemo, useState, useEffect } from "react";
import { isLoggedIn } from '../../Services/Auth';
import { useMediaQuery, useTheme } from '@mui/material';
import { useThemeManager } from '../../Context/ThemeManager';
const AllFooter = () => {
    const { theme} = useThemeManager();
    const location = useLocation();

    const [isMounted, setIsMounted] = useState(false);
    const [LoggedIn, setLoggedIn] = useState(false);
    const isLandingPage = location.pathname === "/";
    // Check initial device type and auth only after mount
    useEffect(() => {
        setLoggedIn(isLoggedIn());
    }, []);
    useEffect(() => {
        document.documentElement.style.setProperty('--footerColor', theme.primaryColor);
        document.documentElement.style.setProperty('--titleGradient', theme.titleGradient);
        document.documentElement.style.setProperty('--footerText', isLandingPage ? "#fff" : theme.footerText);
        document.documentElement.style.setProperty('--bg', theme.bg);
    }, [theme]);

    const muiTheme = useTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('md')); // Detect mobile screen


    // Optional: Watch for login state changes via localStorage (in other tabs)
    useEffect(() => {
        const checkAuth = () => setLoggedIn(!!localStorage.getItem("token"));
        window.addEventListener("storage", checkAuth);
        return () => window.removeEventListener("storage", checkAuth);
    }, []);

    const hiddenFooterRoutes = useMemo(() => {
        if (!isMobile) return [];

        const baseRoutes = [
            "/MyAccount",
            "/MyGroupUsers",
            "/druginteractions",
            "/dosingcalculations",
            "/pregnancyandlactationguide",
            "/dentalantibioticguide",
            "/IMGatewayHerbalInteractions",
            "/ProductDetails",
            "/SearchResults"
        ];

        if (LoggedIn) {
            baseRoutes.push("/feedback", "/privacy", "/about", "/terms");
        }

        return baseRoutes;
    }, [LoggedIn, isMobile]);



    // Calculate whether the footer should be hidden after all states are set
    const [shouldHideFooter, setShouldHideFooter] = useState(false);

    useEffect(() => {
        const path = location.pathname;
        const shouldHide = hiddenFooterRoutes.some(route =>
            path.startsWith(route)
        );
        setShouldHideFooter(isMobile && isLoggedIn && shouldHide);
    }, [location.pathname, isMobile, isLoggedIn, hiddenFooterRoutes]);

    // Conditionally render footer
    if (shouldHideFooter) {
        return null; // Return null to hide the footer
    }


    return (
        <div
            id="Footer"
            style={{zIndex: '1300', display: shouldHideFooter ? 'none' : undefined, backgroundColor: isLandingPage ? isMobile ? "#fff" : "#0262ab" : undefined }}
        >
            <div id="FooterLeft">
                <div><a href="/about" target="_blank">About</a></div>
                <div><a href="/privacy">Privacy</a></div>
                <div><a href="/feedback" target="_blank">Feedback</a></div>
                <div>
                    <a href="/terms">
                        <div className='d-none d-md-inline'>Terms & Conditions</div>
                        <div className='d-inline d-md-none'>Terms</div>
                    </a>
                </div>
                <div>
                    <a href="/#guides" className="scroll-to-guides">
                        <div className='d-none d-md-inline'>Guides & Videos</div>
                        <div className='d-inline d-md-none'>Guides</div>
                    </a>
                </div>
            </div>
            <div id="FooterRight">
                <div><a href="/copyright">&copy; MIMS Australia. All rights reserved.</a></div>
            </div>
        </div>
    );
};

export default AllFooter;
